import axios from 'axios';
import { GETREQUESTOPTIONS } from './apiService';

const API_URL = '/api/cpt-report';

export interface LegacyCptReportInfo {
    name: string | null;
    facilityName: string | null;
    dateOfAssessment: string | null;
    dateOfService: string | null;
    purpose: string | null;
    sources: string[];
    notes: string | null;
    clinicalIndication: string | null;
}

export interface LegacyCptReportSafetyWork {
    purpose: string | null;
    objectives: string | null;
    clinicalIndication: string | null;
}

export interface LegacyCptReportMriSafetyDecisionInfo {
    implantDetails: {
        model: string | null;
        catalogNumber: string | null;
        type: string | null;
        manufacturer: string | null;
    };
    foreignBodyDetails: {
        type: string | null;
        location: string | null;
        description: string | null;
        material: string | null;
        dimensions: string | null;
        hazards: string[];
        hazardExplanation: string | null;
    };
    safetyAnalysis: {
        risk: string | null;
        mitigation: string | null;
        limitSar: string | null;
        sequenceMod: string | null;
        additionalMod: string[];
        staffNeeded: string[];
    };
}

export interface LegacyCptReportConditionalsAnalysis {
    mriStatus: string | null;
    restrictions: string | null;
    hazards: string[];
    riskLevel: 'low' | 'medium' | 'high' | null;
    benefits: {
        benefits: string | null;
        conclusion: string | null;
        explanation: string | null;
    };
}

export interface LegacyCptReportGuidance {
    sopName: string | null;
    sopInfo: {
        title: string | null;
        author: string | null;
        date: string | null;
    };
    sources: string[];
    explanation: string | null;
    recommendation: string | null;
    notes: string | null;
}

export interface LegacyCptReportScannerSettings {
    scannerModel: string | null;
    technique: string | null;
    patientPosition: string | null;
}

export interface LegacyCptReportSummary {
    codes: string[];
    count15: number | null;
    cpt76014: boolean | null;
    cpt76015: number | null;
    totalTimeCPTCodes: number | null;
    notes: string | null;
}

export interface LegacyCptReportApproval {
    approved: boolean;
    date: string | null;
    notes: string | null;
    byId: string | null;
    byName: string | null;
}

export interface LegacyCptReportTimeLogItem {
    task: string | null;
    time: number | null;
}

export interface LegacyCptReport {
    _id: string;
    reportId: string | null;
    status: string | null;
    info: LegacyCptReportInfo;
    safetyWork: LegacyCptReportSafetyWork;
    mriSafetyDecisionInfo: LegacyCptReportMriSafetyDecisionInfo;
    conditionalsAnalysis: LegacyCptReportConditionalsAnalysis;
    guidance: LegacyCptReportGuidance;
    scannerSettings: LegacyCptReportScannerSettings;
    summary: LegacyCptReportSummary;
    approval: LegacyCptReportApproval;
    timeLog: LegacyCptReportTimeLogItem[];
    createdAt: string | null;
    updatedAt: string | null;
}

export const getLegacyCptReports = async (): Promise<LegacyCptReport[]> => {
    const response = await axios.get(API_URL, GETREQUESTOPTIONS());
    return response.data;
};

export const getLegacyCptReportById = async (
    reportId: string
): Promise<LegacyCptReport> => {
    const response = await axios.get(
        `${API_URL}/${reportId}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};
